import { LoadingScreen } from "@/components/elements/Loading/Loading";
import { AdminRoutes, AppRoutes } from "@/routes/config";
import { clientApi, isAuth, setAxiosAuth } from "@/utils/api";
import { createUrlWithParams } from "@/utils/url";
import Cookies from "js-cookie";
import { FC, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const withAuth: <CP extends {}>(WrappedComponent: FC<CP>) => FC<CP> = (WrappedComponent) => (props) => {
  const { pathname } = useLocation();
  const [isVerified, setIsVerified] = useState(false);
  const [userId] = useState(Cookies.get("admin-user-id"));
  const navigate = useNavigate();

  useEffect(() => {
    // Every 2 seconds check user id, if user id has changed then redirect to login page
    const intervalId = setInterval(() => {
      if (userId && userId != Cookies.get("admin-user-id")) {
        const oldUrl = `${location.pathname}${location.search}`;
        const loginUrl = createUrlWithParams(AppRoutes.login, { redirectUrl: oldUrl });
        location.href = loginUrl;
      }
    }, 2000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    // set axios auth at init
    if (isAuth() && !clientApi.defaults.headers.common.Authorization) {
      setAxiosAuth();
    }

    // verify admin routes
    if (!isAuth() && AdminRoutes.some((path) => pathname.startsWith(path))) {
      const oldUrl = `${location.pathname}${location.search}`;
      const loginUrl = createUrlWithParams(AppRoutes.login, { redirectUrl: oldUrl });
      location.href = loginUrl;
      return;
    }

    setIsVerified(true);
  }, [pathname, navigate]);

  if (!isVerified) return <LoadingScreen />;

  return <WrappedComponent {...props} />;
};
